import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'

import * as managerActions from 'common/builder/actions/manager/managerActions'
import { BuilderValue, IBuilderState, ManagerValue } from 'common/builder/builderInterfaces'
import * as builderStateSelectors from 'common/builder/selectors/builder/builderStateSelectors'
import * as commonSelectors from 'common/builder/selectors/builder/commonSelectors'
import * as managerSelectors from 'common/builder/selectors/managerSelectors'

interface NotReady {
  isBuilderReady: false
  flowId: string

  managerId: undefined
  builderId: undefined
  builder: undefined
  manager: undefined
}
interface Ready {
  isBuilderReady: true
  flowId: string

  managerId: string
  builderId: string
  builder: BuilderValue
  manager: ManagerValue
}

export const VIRTUAL_FLOW_ID = 'virtual_flow'

const useVirtualBuilder = (): NotReady | Ready => {
  const dispatch = useAppDispatch()

  const [managerId, setManagerId] = useState('')
  const manager = useAppSelector((state) => managerSelectors.getById(state, managerId)) as
    | ManagerValue
    | undefined
  const builderId = manager?.builderId || ''
  const builder = useAppSelector((state) => commonSelectors.getBuilderById(state, builderId)) as
    | BuilderValue
    | undefined
  const builderState = useAppSelector((state) =>
    builderStateSelectors.getById(state, builderId),
  ) as IBuilderState | undefined

  const initManager = () => {
    const options = {
      flowId: VIRTUAL_FLOW_ID,
      chId: '',
      defaultChId: '',
      viewerMode: false,
      builderOptions: {},
      independentMode: true,
    }

    const manager = dispatch(managerActions.createManagerState(options)) as unknown as ManagerValue
    setManagerId(manager.id)
  }
  useEffect(initManager, [dispatch])

  const isReady =
    managerId &&
    manager &&
    builderId &&
    builder &&
    manager.isBuilderReady &&
    builderState &&
    !builderState.isLoading

  if (isReady) {
    return {
      isBuilderReady: true,
      flowId: VIRTUAL_FLOW_ID,

      managerId,
      manager,
      builderId,
      builder,
    }
  }

  return {
    isBuilderReady: false,
    flowId: VIRTUAL_FLOW_ID,

    managerId: undefined,
    manager: undefined,
    builderId: undefined,
    builder: undefined,
  }
}

export default useVirtualBuilder
